// extracted by mini-css-extract-plugin
export default {"root":"Modal_root__z7+I3","wrapper":"Modal_wrapper__TlE5n","close":"Modal_close__V34Fj"};